module.exports = __webpack_public_path__ + "static/media/epargn-icon.0db40614.svg";